import React from 'react';
import { Container, makeStyles } from '@material-ui/core';

import { Category } from 'domain/types';
import CategoryNavigationItem from './CategoryNavigationItem';

interface CategoryNavigationProps {
  categories: Array<Category>;
  categorySlug?: string;
}

const CategoryNavigation: React.FC<CategoryNavigationProps> = ({
  categories,
  categorySlug = ''
}): JSX.Element => {
  const classes = useStyles();

  return (
    <Container className={classes.container}>
      <div className={classes.grid}>
        {categories.map((category) => (
          <CategoryNavigationItem
            category={category}
            isSelected={categorySlug === category.slug}
            key={category.sys.id}
          />
        ))}
      </div>
    </Container>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(6)
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr))',
      gap: 4
    }
  }
}));

export default CategoryNavigation;
